import { useParams } from "@tanstack/react-router";

// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import { ContractCardForm } from "./ContractCardForm";
import { ExistingContract } from "./ExistingContract";

export function ContractCard() {
  const { id } = useParams({ strict: false });

  return (
    <>
      {id == "new" ? (
        <>
          <GenericListHeader heading={"New Contract"} />
          <ContractCardForm newContract />
        </>
      ) : (
        <ExistingContract id={id} />
      )}
    </>
  );
}
